/* unplugin-vue-components disabled */// extracted by css-extract-rspack-plugin
export default {"container":"not-found_container__Bs-DN"};